<template>
  <div class="pc-header">
    <div class="data-body">
      <div class="cont-left">
        <div
          v-if="extras.logo.display === 1 && extras.logo.colorOrBg == 'color'"
          :style="{
            background: extras && extras.logo ? extras.logo.color : '',
          }"
        ></div>
        <img
          v-if="extras.logo.display === 1 && extras.logo.colorOrBg == 'src'"
          :src="extras.logo.src ? extras.logo.src : imgUrlObj.logo"
        />
      </div>
      <div class="g-menu">
        <ul>
          <li
            v-for="(item, index) in titleItem"
            :key="index"
            v-show="extras[item.key].display == 1"
            :style="{ '--bgcolor': extras['themecolor'].bgcolor }"
            :class="{
              active: number === item.key,
              'cursor-default': isSetting == 1,
            }"
            @click="JumpClick(item)"
          >
            {{ extras[item.titleKey].model || item.title }}
          </li>
        </ul>
      </div>
      <div
        class="g-right-new"
        v-show="isLogin && seminarInfo.isOpenMember != 0"
      >
        <img
          class="member-header"
          v-if="memberInfo.headImg"
          :src="memberInfo.headImg"
          @click="gotoUserCenter"
        />
        <a
          class="top-btn member-name"
          :title="memberInfo.name"
          @click="gotoUserCenter"
          >{{ memberInfo.name }}</a
        >
        <a @click="logout" class="top-btn">退出</a>
      </div>
      <div
        class="g-right-new"
        v-show="!isLogin && seminarInfo.isOpenMember != 0"
      >
        <a
          :class="{
            'cursor-default': isSetting == 1,
          }"
          @click="goto('login')"
          class="top-btn"
          >登录</a
        >
        <a
          :class="{
            'cursor-default': isSetting == 1,
          }"
          @click="goto('register')"
          class="top-btn"
          >注册</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { URLS } from "fire-wind-water";
import { goto } from "../../mixins/goto";
export default {
  name: "Header",
  props: {
    seminarInfo: Object,
    memberInfo: Object,
    extras: Object,
    loginUrl: String,
    registerUrl: String,
  },
  data() {
    return {
      isLogin: false,
      imgUrlObj: {
        logo: require("@/assets/images/pc/logo.png"),
        defaultHeader: require("@/assets/images/pc/default-header.png"),
      },
      isSetting: 0,
      userCenterUrl: "",
      number: 0,
      titleItem: [
        {
          title: "大会简介",
          key: "introduction",
          titleKey: "introductionTitle",
        },
        {
          title: "参会嘉宾",
          key: "meetingGuest",
          titleKey: "meetingGuestTitle",
        },
        {
          title: "会议日程",
          key: "meetingAgenda",
          titleKey: "meetingAgendaTitle",
        },

        { title: "新闻资讯", key: "message", titleKey: "messageTitle" },
        { title: "合作伙伴", key: "partner", titleKey: "partnerTitle" },
        { title: "资料下载", key: "download", titleKey: "downloadTitle" },
      ],
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    const { tenantId, schemaId, memberFormId } = this.seminarInfo;
    // const { usercenterUrl } = window.config;
    this.userCenterUrl = `index.html?tenantId=${tenantId}&schemaId=${schemaId}&memberFormId=${memberFormId}`;
    // this.userCenterUrl = `${usercenterUrl}index.html?tenantId=${tenantId}&schemaId=${schemaId}&memberFormId=${memberFormId}`;
    const info = window.$sk.template.get();
    const smarketMember = info.cookie.getSession();
    this.isLogin = !!smarketMember;
    if (URLS.getURL("isSetting") == 1) {
      this.isLogin = false;
    }
  },
  methods: {
    goto(s) {
      switch (s) {
        case "login":
          goto.login();
          break;
        case "register":
          goto.register();
          break;
      }
    },
    gotoUrl: function (url) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (url) {
        // window.$sk.goto(url);
        window.$sk.goto(url);
      }
    },
    gotoUserCenter: function () {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      // Api.getDomain(this.seminarInfo.tenantId).subscribe((res) => {
      //   if (res.result === 0) {
      //     window.location.href = `//${res.content.domain}/usercenter/${this.userCenterUrl}`;
      //   }
      // });
      window.$sk.goto(
        `${window.$sk.config.usercenterUrl}${this.userCenterUrl}`
      );
    },
    logout: function () {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      let r = confirm("你确定退出吗?");
      if (r == true) {
        this.isLogin = false;
        this.$emit("logout");
      }
    },
    JumpClick(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.number = item.key;
      this.$emit("routerEvent", item);
    },
  },
};
</script>

<style scoped></style>
